"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _actions = require("./actions");

var _Pixel = _interopRequireDefault(require("./Pixel"));

var _handleActions;

var initialState = (0, _immutable.fromJS)({
  pixels: (0, _immutable.List)()
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchPixelsActionTypes.SUCCESS, function (state, action) {
  return state.set('pixels', (0, _immutable.List)(action.payload.data.results.map(function (pixel) {
    return (0, _Pixel.default)(pixel);
  })));
}), (0, _defineProperty2.default)(_handleActions, _actions.CreateAndInstallPixelsActionTypes.SUCCESS, function (state, action) {
  return action.payload.data.reduce(function (newState, pixelData) {
    var installedPixelIndex = newState.get('pixels').findIndex(function (pixel) {
      return pixel.id === pixelData.pixelId;
    });
    return newState.updateIn(['pixels', installedPixelIndex], function (pixel) {
      return pixel.set('installed', true);
    });
  }, state);
}), (0, _defineProperty2.default)(_handleActions, _actions.UninstallPixelActionTypes.SUCCESS, function (state, action) {
  var uninstalledPixelIndex = state.get('pixels').findIndex(function (pixel) {
    return pixel.id === action.payload.props.id;
  });
  return state.updateIn(['pixels', uninstalledPixelIndex], function (pixel) {
    return pixel.set('installed', false);
  });
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;